import React from "react";

const STATUS_VARIANTS = {
  connected: 'success', active: 'success', paid: 'success', approved: 'success', succeeded: 'success',
  draft: 'warning', pending: 'warning', past_due: 'warning', unpaid: 'warning',
  disconnected: 'danger', archived: 'danger', canceled: 'danger', uncollectible: 'danger', denied: 'danger', failed: 'danger',
  info: 'info', trialing: 'info', open: 'info', ach_processing: 'info',
  paused: 'neutral', refunded: 'neutral', incomplete: 'neutral', incomplete_expired: 'neutral', void: 'neutral', reviewing: 'neutral', resolved: 'neutral',
};

const VARIANT_STYLES = {
  success: { backgroundColor: 'var(--sl-bg-success-primary)', color: 'var(--sl-text-success)' },
  warning: { backgroundColor: 'var(--sl-bg-warning-primary)', color: 'var(--sl-text-warning)' },
  danger: { backgroundColor: 'var(--sl-bg-error-primary)', color: 'var(--sl-text-error)' },
  info: { backgroundColor: 'var(--sl-bg-brand-primary)', color: 'var(--sl-text-brand)' },
  neutral: { backgroundColor: 'var(--sl-bg-tertiary)', color: 'var(--sl-text-secondary)' },
};

const humanize = (value) => {
  if (!value) return value;
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

const StatusBadge = ({ status, label }) => {
  const variant = STATUS_VARIANTS[status] || 'info';
  return (
    <span
      className={`status-badge status-badge--${variant}`}
      style={{
        fontSize: 12,
        fontWeight: 500,
        padding: '2px 10px',
        borderRadius: 16,
        whiteSpace: 'nowrap',
        ...VARIANT_STYLES[variant],
      }}
    >
      {label || humanize(status)}
    </span>
  );
};

export { STATUS_VARIANTS, VARIANT_STYLES };
export default StatusBadge;
